import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {FS3ValidationResult} from "../../../objects/validationResult";
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {ListItem} from "../../../objects/listItem";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {SharedDataService} from "../../../services/shared-data.service";
import {DialogCanvasComponent} from "../../dialog-canvas/dialog-canvas.component";
import {environment} from "../../../../environments/environment";
import {FS3Notification} from "../../../objects/notification";
import {AppEvent} from "../../../objects/appEvent";
import {MatCalendarCellClassFunction, MatDatepickerInputEvent} from "@angular/material/datepicker";
import {FormatterInput} from "@fullcalendar/common";
import {getFullTwoWeeks, DAY, hoursToSeconds} from "../../../utils/parseUtils";
import {DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import {colors} from "../../../consts/colors";
import {EventApi} from "@fullcalendar/angular";
import {User} from "../../../objects/user";

@Component({
  selector: 'app-schedule-calendar-event-form',
  templateUrl: './schedule-calendar-event-form.component.html',
  styleUrls: ['../mobile-container/mobile-container.component.scss'],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'uk-UA'},
  ]
})
export class ScheduleCalendarEventFormComponent implements OnInit {
  @Input() application: AppComponent;
  @Input() payload: object;
  @Output() success = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  @ViewChild('eventStartInputElem') public eventStartInputElem: ElementRef<HTMLElement>;
  @ViewChild('eventEndInputElem') public eventEndInputElem: ElementRef<HTMLElement>;

  private formValidationMessages = {
    required: 'Value required.',
  };
  public validationResult: FS3ValidationResult;
  public componentForm: FormGroup = new FormGroup({});
  public eventStartInput: FormControl = new FormControl('', [Validators.required]);
  private eventStartValue: number;
  public eventHourStart: FormControl = new FormControl('', [Validators.required]);
  public eventEndInput: FormControl = new FormControl('', [Validators.required]);
  private eventEndValue: number;
  public eventHourEnd: FormControl = new FormControl('', [Validators.required]);
  public scheduleTypeInput: FormControl = new FormControl('', [Validators.required]);
  public duplicateChanges: FormControl = new FormControl('');

  state: string = 'edit';
  errMsg: string = '';
  public item: EventApi;
  public fromDate: Date = ((): Date => {
    let d = new Date();
    d.setTime(Math.floor(d.getTime()/(DAY))*DAY)
    return d;
  })();
  public toDate: Date = getFullTwoWeeks();
  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    // Only highligh dates inside the month view.
    if (view === 'month') {
      const cellTime = cellDate.getTime();
      const fromTime = this.fromDate.getTime();
      const toTime = this.toDate.getTime();
      if( (cellTime+DAY) > fromTime && cellTime <= toTime) {
        return 'highlight-date-class'
      }
    }
    return '';
  };
  //public settings: object = environment['calendars'][0]; //todo maybe have multiple calendars
  public settings: object;
  public hours: string[]
  public scheduleTypes: object[] = ((): object[] => {
    let types: object[] = []
    types.push({
      css_class: 'marker-green',
      key: 'available',
      label: AppComponent.getLabel('available'),
    })
    types.push({
      css_class: 'marker-red',
      key: 'absent',
      label: AppComponent.getLabel('absent'),
    })
    return types;
  })()
  selectedTypeIdx: number = 0

  dateFormatter: FormatterInput = {
    month: 'long',
    day: 'numeric',
  }
  hourStart: string;
  minutesStart: string;
  hourEnd: string;
  minutesEnd: string;
  eventPayload: object;

  constructor(public dialog: MatDialog,
              private _adapter: DateAdapter<any>,
              private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    this.settings = {
      "start":AppComponent.convertHMtoSeconds(this.application.account.calendars[0]['parsed_params']['start_hour']),
      "end":AppComponent.convertHMtoSeconds(this.application.account.calendars[0]['parsed_params']['end_hour']),
      "duration":this.application.account.calendars[0]['parsed_params']['duration']
    };
    //console.log(this.settings,'this.settings');
    this.hours = ((): string[] => {
      const settings = this.settings;
      let hours: string[] = []
      let start: number = settings['start'];
      let hour: number = 0;
      let minutes: number = 0;
      while(start <= settings['end']) {
        hour = Math.floor(start/3600);
        minutes = (start-hour*3600)/60;
        hours.push( ((hour < 10) ? '0'+hour : hour) + ':' + (minutes ? minutes : '00'));
        start+= settings['duration'];
      }
      return hours;
    })()

    this._adapter.setLocale('uk');
    this.item = this.payload['item'];
    this.componentForm.addControl('eventStartInput', this.eventStartInput);
    this.componentForm.addControl('eventHourStart', this.eventHourStart);
    this.componentForm.addControl('eventEndInput', this.eventEndInput);
    this.componentForm.addControl('eventHourEnd', this.eventHourEnd);
    this.componentForm.addControl('scheduleTypeInput', this.scheduleTypeInput);
    this.componentForm.addControl('duplicateChanges', this.duplicateChanges);

    //this.eventHourStart.setValue('10:40')
    //this.selectedTypeIdx = Math.max(0,this.scheduleTypes.findIndex(elem => { return elem['key'] == this.scheduleTypes['value'] }))

    if(this.item) {
      //console.log('this.item',this.item)
      this.hourStart = (this.item.start.getHours() < 10) ? '0'+this.item.start.getHours() : this.item.start.getHours()+'';
      this.minutesStart = (this.item.start.getMinutes()) ? ''+this.item.start.getMinutes() : '00';
      this.hourEnd = (this.item.end.getHours() < 10) ? '0'+this.item.end.getHours() : this.item.end.getHours()+'';
      this.minutesEnd = (this.item.end.getMinutes()) ? ''+this.item.end.getMinutes() : '00';
    }
    // if(this.item?.extendedProps['schedule_type'] == 'training') {
    //   this.eventPayload = JSON.parse(this.item.extendedProps['payload']);
    //   //console.log('this.eventPayload',this.eventPayload)
    // }
    //if(this.item && this.item.extendedProps['schedule_type'] != 'training') {
    if(this.item) {
      this.eventStartInput.setValue(this.item.start);
      this.eventStartValue = this.item.start.getTime()
      this.eventEndInput.setValue(this.item.end);
      this.eventEndValue = this.item.end.getTime()
      setTimeout(() => {
        this.eventStartInputElem.nativeElement['value'] = this.payload['calendarApi'].formatDate(this.item.start,this.dateFormatter);
        this.eventEndInputElem.nativeElement['value'] = this.payload['calendarApi'].formatDate(this.item.end,this.dateFormatter);
      })
      this.eventHourStart.setValue(this.hourStart+':'+this.minutesStart)
      this.eventHourEnd.setValue(this.hourEnd+':'+this.minutesEnd)

      this.selectedTypeIdx = Math.max(0,this.scheduleTypes.findIndex(elem => { return elem['key'] == this.item.extendedProps['schedule_type'] }))
      this.scheduleTypeInput.setValue(this.scheduleTypes[this.selectedTypeIdx]['key']);
    } else {
      this.scheduleTypeInput.setValue(this.scheduleTypes[0]['key']);
    }
  }

  public dateInputClick(event,picker): void {
    event.currentTarget.blur()
    event.stopImmediatePropagation();
    picker.open();
  }
  dateChangeEvent(event: MatDatepickerInputEvent<Date>, isStart:boolean) {
    const cellTime = event.value.getTime();
    const fromTime = this.fromDate.getTime();
    const toTime = this.toDate.getTime();
    if( (cellTime+DAY) <= fromTime) {
      isStart ? this.eventStartInput.setValue(this.fromDate) : this.eventEndInput.setValue(this.fromDate);
      event.value = this.fromDate;
    }
    if( cellTime > toTime) {
      isStart ? this.eventStartInput.setValue(this.toDate) : this.eventEndInput.setValue(this.toDate);
      event.value = this.toDate;
    }

    //this.eventStartInput.setValue(this.toDate);

    event.targetElement['value'] = this.payload['calendarApi'].formatDate(event.value,this.dateFormatter);
    if(isStart) {
      this.eventStartValue = event.value.getTime()
      if(this.eventEndValue < this.eventStartValue || !this.eventEndValue) {
        this.eventEndValue = this.eventStartValue;
        this.eventEndInput.setValue(event.value);
        this.eventEndInputElem.nativeElement['value'] = event.targetElement['value'];
      }
    } else {
      this.eventEndValue = event.value.getTime()
      if(this.eventEndValue < this.eventStartValue || !this.eventStartValue) {
        this.eventStartValue = this.eventEndValue;
        this.eventStartInput.setValue(event.value);
        this.eventStartInputElem.nativeElement['value'] = event.targetElement['value'];
      }
    }
    //event.targetElement['value'] = event.value.getDate()+' '+event.value.getMonth();
    //this.events.push(`${type}: ${event.value}`);
    //event.stopImmediatePropagation
  }
  hourChange(isStart:boolean) {
    const start = hoursToSeconds(this.eventHourStart.value)
    const end = hoursToSeconds(this.eventHourEnd.value)
    if( start >= end || !start || !end) {
      isStart ?
        this.eventHourEnd.setValue(this.hours[this.hours.indexOf(this.eventHourStart.value)+1]) :
        this.eventHourStart.setValue(this.hours[this.hours.indexOf(this.eventHourEnd.value)-1]);
    }
  }
  typeChange() {
    this.selectedTypeIdx = Math.max(0,this.scheduleTypes.findIndex(elem => { return elem['key'] == this.scheduleTypeInput.value }))
  }

  public handleSubmit(event: Event | void = null): boolean {
    if (event) {
      event.stopPropagation();
    }

    this.validationResult = null;
    [this.eventStartInput,this.eventEndInput,this.eventHourStart,this.eventHourEnd].forEach(elem => {
      if (!elem.valid) {
        elem.markAsTouched()
        const errorKey = Object.keys(elem.errors)[0]; // get error key from input errors
        this.validationResult = {
          isValid: false,
          message: this.formValidationMessages[errorKey]
        };
      }
    });

    if (this.validationResult) {
      return false;
    }

    this.updateSchedule();
    return false
  }

  private updateSchedule(deleteItem: boolean = false, duplicateChanges: boolean = false) {
    this.state = 'loading';
    let configToSave;
    if(!deleteItem) {
      configToSave = {
        label: 'Add schedule',
        event_start_day: this.eventStartValue/1000,
        days_batch: (this.eventEndValue-this.eventStartValue)/DAY+1,
        event_hours: this.eventHourStart.value,
        event_seconds: hoursToSeconds(this.eventHourStart.value),
        duration: hoursToSeconds(this.eventHourEnd.value) - hoursToSeconds(this.eventHourStart.value),
        schedule_type: this.scheduleTypes[this.selectedTypeIdx]['key'],
        duplicate_changes: this.duplicateChanges.value,
        group_key: this.item ? this.item.extendedProps['group_key'] : '',
      }
    } else {
      configToSave = {
        delete_item: true,
        duplicate_changes: duplicateChanges,
        group_key: this.item.extendedProps['group_key'],
      }
    }
    this.application.apiService
      .updateEventItem(
        environment['gid'],environment['g_hash'], '',
        this.payload['item'] ? this.payload['item']['id'] : null,
        'profile_event','schedule_add',configToSave)
      .subscribe(
        res => {
          let notification = new FS3Notification();
          notification.type = 'success';
          notification.text = AppComponent.getLabel('schedule_updated');
          this.sharedDataService.pushNotification(notification);
          if(!this.payload['item']) { //append new item to list
            // let listItem = this.application.apiService.extractClubEventsData([data])[0];
            let appEvent = new AppEvent(AppEvent.SCHEDULE_ADDED, {bookingEvents: this.application.apiService.extractBookingData(res)});
            this.sharedDataService.pushAppEvent(appEvent)
          } else {
            let appEvent = new AppEvent(AppEvent.SCHEDULE_UPDATED, {});
            this.sharedDataService.pushAppEvent(appEvent)
          }
          this.success.emit()
        },
        error => {
          const { exception } = error;
          const errMsg = error['errMsg'] ? error['errMsg'] : (
            (exception && exception.error && exception.error.message) ? exception.error.message : 'Error'
          );
          let notification = new FS3Notification();
          notification.type = 'error';
          notification.text = errMsg;
          this.sharedDataService.pushNotification(notification);
          this.state = 'edit'
          this.validationResult = {
            isValid: false,
            message: errMsg
          };
        }
      )
  }

  public showUser(profile: User): void {
    console.log('todo',profile)
  }

  public onNoClick(): void {
    //this.dialogRef.close({ isConfirmed: false });
    this.close.emit()
  }

  public deleteEvent(): void {
    // this.close.emit()
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      height: 'auto',
      data: {
        application: this,
        state: 'schedule-event-delete',
        payload: {
          //folderUUID: this.urlAfterRedirects.split('/')[3],
        }
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((dialogPayload) => {
        if(dialogPayload) {
          this.updateSchedule(true,dialogPayload['duplicateChanges'])
        }
      })
  }

}
